var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAverage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Average",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8816 19.0007C12.9521 19.0524 13.0479 19.0524 13.1184 19.0006L23.6311 11.2753L26 9.54379L13 0L0 9.54379L2.35444 11.2753L12.8816 19.0007ZM13.1039 22.4637C13.0335 22.5154 12.9376 22.5154 12.8672 22.4638L2.34 14.7383L0 16.4562L13 26L26 16.4562L23.6456 14.7247L13.1039 22.4637ZM12.0692 10.2135L9.60522 13.6575L9.73122 13.9375H11.2432L12.9932 11.4315L14.7432 13.9375H16.2692L16.3952 13.6575L13.9312 10.2135L16.3252 6.8675L16.1852 6.5875H14.6732L12.9932 8.9955L11.3272 6.5875H9.81522L9.67522 6.8675L12.0692 10.2135ZM11.0409 4.0675V5.2575H14.9749V4.0675H11.0409Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAverage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/average.a99c81d09be6e975e85b5b05ddf91031.svg";